<script setup lang="ts">
import { MoreHorizontal } from 'lucide-vue-next';
</script>

<template>
  <div class="doc-prose max-w-none">
    <blockquote class="!mt-0 !mb-0">
      <p class="mb-0 text-[0.9375rem] leading-[1.65] text-inherit">
        Beyond the basic controls, click the far-right
        <span
          class="inline-flex h-8 items-center justify-center rounded-xl border border-black/[0.12] dark:border-white/[0.14] px-2 align-[-0.2em] mx-0.5 shrink-0 select-none"
          aria-hidden="true"
        >
          <MoreHorizontal class="w-4 h-4 text-black/50 dark:text-white/50" />
        </span>
        button to open the **Design panel** on the left with **Color**, **Decoration**, and **Font**
        tabs.
      </p>
    </blockquote>
  </div>
</template>
